const IconStarEmpty = () => {
	return (
		<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				id="Star 36"
				// eslint-disable-next-line max-len
				d="M18.0516 1.03827C18.235 0.666645 18.765 0.666646 18.9484 1.03827L23.8438 10.9574C24.0623 11.4001 24.4846 11.707 24.9732 11.778L35.9196 13.3686C36.3297 13.4282 36.4935 13.9322 36.1967 14.2214L28.2758 21.9424C27.9223 22.287 27.7609 22.7835 27.8444 23.2701L29.7143 34.1723C29.7843 34.5808 29.3556 34.8922 28.9888 34.6994L19.198 29.5521C18.761 29.3223 18.239 29.3223 17.802 29.5521L8.0112 34.6994C7.64439 34.8922 7.21567 34.5808 7.28573 34.1723L9.1556 23.2701C9.23906 22.7835 9.07774 22.287 8.72421 21.9424L0.803297 14.2214C0.506539 13.9322 0.670293 13.4282 1.0804 13.3686L12.0268 11.778C12.5154 11.707 12.9377 11.4001 13.1562 10.9574L18.0516 1.03827Z"
				stroke="#ECAD24"
			/>
		</svg>
	);
};

export default IconStarEmpty;
